import Layout from '@/page/index/'
export default [
  {
    path: '/',
    component: (resolve) => require(['@/page/index/index'], resolve),
    name: '主页',
    children: [
      {
        path: '/qc/flow/:id',
        component: (resolve) => require(['@/views/qc/qc-detail'], resolve),
        name: '质控任务详情',
        meta: {
          keepAlive: false,
          isTab: true,
          isAuth: false,
        },
      },
      {
        path: '/qc/flow/multi-qc/:id',
        component: (resolve) => require(['@/views/qc/multi-qc'], resolve),
        name: '质控任务配置',
        meta: {
          keepAlive: true,
          isTab: true,
          isAuth: false,
        },
      },
      {
        path: '/qc/flow/uniform-check/:id',
        name: '智能检测',
        meta: {
          keepAlive: false,
          isTab: true,
          isAuth: false,
        },
        component: (resolve) => require(['@/views/qc/uniformCheck'], resolve),
      },
      {
        path: '/qc/flow/qc-check/:id',
        name: '智能检测',
        meta: {
          keepAlive: false,
          isTab: true,
          isAuth: false,
        },
        component: (resolve) => require(['@/views/qc/qcCheck'], resolve),
      },
    ],
  },
];
